export const UpdateSupplierValidation = (formData) => {
    const errors = {};

    if (!formData.vc_Notes || !formData.vc_Notes.trim()) {
        errors.vc_Notes = 'This field is required';
    }

    
    return errors;
};
